import{DipApiScopeEnum as s}from"@danfoss-source/dip-helpers/dist/es/consts/dip";const e=[s.ReadUserCustomerIds];export{e as SECURED_KEYS_API_SCOPES};
